import {
  MemberProductPaymentRatesChargeCode,
  MemberProfile,
} from "@/services/core-api-adapter";
import { Typography } from "@mui/material";
import { TFunction } from "i18next";
import { formatAmount } from "@/utils";

export enum DashboardServiceOfferingTypes {
  DOCTOR_AND_NURSE_CONSULT = "DOCTOR_AND_NURSE_CONSULT",
  BLOOD_TESTS = "BLOOD_TESTS",
  HEALTH_CHECK = "HEALTH_CHECK",
  BUY_VOUCHER = "BUY_VOUCHER",
  DOC_MED_BUNDLE = "DOC_MED_BUNDLE",
}

export default function FeaturedServiceOfferingOptions(
  memberProfile: MemberProfile | null,
  t: TFunction
) {
  if (!memberProfile) {
    return [];
  }
  return (
    memberProfile.offerings
      ?.filter((offering) => offering.isFeatured === true)
      .map((offering) => ({
        type:
          offering.chargeCode ===
          MemberProductPaymentRatesChargeCode.DIGITAL_DOCTOR_MEDICINE_CONSULT
            ? DashboardServiceOfferingTypes.DOC_MED_BUNDLE
            : offering.chargeCode ===
                MemberProductPaymentRatesChargeCode.DIGITAL_DOCTOR_CONSULT
              ? DashboardServiceOfferingTypes.DOCTOR_AND_NURSE_CONSULT
              : offering.chargeCode ===
                  MemberProductPaymentRatesChargeCode.VOUCHER_ONLINE_DOCTOR_CONSULTATION
                ? DashboardServiceOfferingTypes.BUY_VOUCHER
                : "",
        name:
          offering.chargeCode ===
          MemberProductPaymentRatesChargeCode.DIGITAL_DOCTOR_MEDICINE_CONSULT
            ? t("PayGMemberDashboard.DocMedBundle.panel.title")
            : offering.chargeCode ===
                MemberProductPaymentRatesChargeCode.DIGITAL_DOCTOR_CONSULT
              ? t("PayGMemberDashboard.doctorAndNurseConsult.panel.title")
              : offering.chargeCode ===
                  MemberProductPaymentRatesChargeCode.VOUCHER_ONLINE_DOCTOR_CONSULTATION
                ? t("PayGMemberDashboard.Voucher.panel.title")
                : "",
        description:
          offering.chargeCode ===
          MemberProductPaymentRatesChargeCode.DIGITAL_DOCTOR_MEDICINE_CONSULT
            ? "PayGMemberDashboard.DocMedBundle.panel.subtitle"
            : offering.chargeCode ===
                MemberProductPaymentRatesChargeCode.DIGITAL_DOCTOR_CONSULT
              ? t("PayGMemberDashboard.doctorAndNurseConsult.panel.subtitle")
              : offering.chargeCode ===
                  MemberProductPaymentRatesChargeCode.VOUCHER_ONLINE_DOCTOR_CONSULTATION
                ? t("PayGMemberDashboard.Voucher.panel.description")
                : "",
        route: "/home/get-medical-assistance/intercare?isDocMedsBundle=true",
        amount: offering.amount,
        currencyCode: offering.currencyCode,
        isDiscountApplied: offering.isDiscountApplied,
        originalAmount: offering.originalAmount,
        leftButton: (
          <Typography fontWeight={600} color="info">
            {t("PayGMemberDashboard.FeaturedServiceOffering.panel.price", {
              priceFormatted: formatAmount(
                offering.amount || 0,
                offering.currencyCode || ""
              ),
            })}
          </Typography>
        ),
        rightButton: (
          <Typography fontWeight={600} color="primary">
            {t(
              "PayGMemberDashboard.FeaturedServiceOffering.panel.rightButton.title"
            )}
          </Typography>
        ),
      })) || []
  );
}
